import styled from "styled-components";

export const LoadingStyle = styled.div`
  .text {
    text-align: center;
    font-size: 18px;
    color: black;
  }
`;
